import React from 'react';
import Check from '@mui/icons-material/Check';
import { Grid, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import consulta_autovalid from '../../assets/images/consulta_autovalid.svg';
import { brandTokens } from '../single-page/theme';

const SECTION_BG = brandTokens.tonal;
const CHECK_ACCENT = brandTokens.blueAccent;
const TEXT_MUTED = '#424242';

const RootGrid = styled(Grid)({
  position: 'relative',
  width: '100%',
  margin: 0,
  backgroundColor: SECTION_BG,
});

const ContentContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8, 4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 2),
  },
}));

const ComparisonCard = styled(Box)(({ theme }) => ({
  background: '#FFFFFF',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.28)',
  borderTop: `4px solid ${brandTokens.green}`,
  padding: theme.spacing(6, 7),
  maxWidth: '960px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 3),
  },
}));

const TitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(4),
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '28px',
  lineHeight: 1.3,
  color: TEXT_MUTED,
  [theme.breakpoints.down('sm')]: {
    fontSize: '22px',
  },
}));

const BadgeImage = styled('img')(({ theme }) => ({
  height: '100px',
  width: 'auto',
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    height: '56px',
  },
}));

const TwoColumnGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: theme.spacing(6),
  rowGap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    columnGap: 0,
    rowGap: theme.spacing(1.5),
  },
}));

const Column = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1.5),
  },
}));

const ChecklistItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

const CheckCircle = styled(Box)({
  width: 28,
  height: 28,
  borderRadius: '50%',
  backgroundColor: CHECK_ACCENT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

const ItemText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: 1.5,
  color: TEXT_MUTED,
});

const MeetOurInspections = () => {
  const leftColumn = [
    'Pesquisa de procedência',
    'Leilão',
    'Sinistro',
    'Furto',
  ];
  const rightColumn = ['Impedimentos', 'Restrições judiciais', 'Débitos'];

  return (
    <RootGrid>
      <ContentContainer>
        <ComparisonCard>
          <TitleRow>
            <CardTitle component="h2">Dados da consulta</CardTitle>
            <BadgeImage src={consulta_autovalid} alt="Consulte AutoValid" />
          </TitleRow>
          <TwoColumnGrid>
            <Column>
              {leftColumn.map((label) => (
                <ChecklistItem key={label}>
                  <CheckCircle>
                    <Check sx={{ color: '#fff', fontSize: 18 }} />
                  </CheckCircle>
                  <ItemText component="span">{label}</ItemText>
                </ChecklistItem>
              ))}
            </Column>
            <Column>
              {rightColumn.map((label) => (
                <ChecklistItem key={label}>
                  <CheckCircle>
                    <Check sx={{ color: '#fff', fontSize: 18 }} />
                  </CheckCircle>
                  <ItemText component="span">{label}</ItemText>
                </ChecklistItem>
              ))}
            </Column>
          </TwoColumnGrid>
        </ComparisonCard>
      </ContentContainer>
    </RootGrid>
  );
};

export default MeetOurInspections;
